import { App } from "app";
import { createRoot } from "react-dom/client";

import { mixpanel } from "./common/analytics";
// catch all unhandled rejections
window.addEventListener("unhandledrejection", function (event) {
  event = event || {};
  console.error(
    "Unhandled rejection (promise: ",
    event.promise,
    ", reason: ",
    event.reason,
    ")."
  );
});

// Mixpanel initialization has to happen before we run any other
// code running mixanel logic; otherwise it fails with errors.
const mixpanelToken = import.meta.env.VITE_MIXPANEL_TOKEN ?? "";

const mixpanelOpts = { api_host: "https://api-eu.mixpanel.com" };

mixpanel.init(mixpanelToken, mixpanelOpts);
mixpanel.register({ gitsha: import.meta.env.VITE_GITSHA ?? "" });

const container = document.getElementById("root");
if (container) {
  const root = createRoot(container);
  root.render(<App />);
}
